<app-card-base [title]="title" [hasSubmit]="false" [hasFooter]="true">
  <ng-container header-right *ngTemplateOutlet="headerRight"></ng-container>
  <ng-container main *ngTemplateOutlet="contentMain"></ng-container>
</app-card-base>

<ng-template #contentMain>
  @if(insulation){
  <div class="content">
    <div class="details">
      <div *ngIf="insulation.installationDate"><span class="title">Date des travaux</span><span
          class="content">{{insulation.installationDate
          | dateFormat}}</span>
      </div>
      <div *ngIf="insulation.thickness"><span class="title">Épaisseur</span><span
          class="content">{{insulation.thickness}}
          mm</span>
      </div>
      <div *ngIf="insulation?.thermalResistance"><span class="title">Résistance thermique</span><span
          class="content">{{insulation.thermalResistance}} m²K/W</span>
      </div>

      <div class="detail-doc" [class.is-sent]="insulation.productSheet">
        <span>Fiche produit</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="insulation.productSheet ? 'Document enregistré' : 'Document absent'">
          {{insulation.productSheet ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      <div class="detail-doc" [class.is-sent]="insulation.installationDetails">
        <span>Détails de l'installation</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="insulation.installationDetails ? 'Document enregistré' : 'Document absent'">
          {{insulation.installationDetails ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
    </div>
  </div>
  } @else {
  <div class="summary">{{summary}}</div>
  }
</ng-template>

<ng-template #headerRight>
  <button mat-flat-button color="primary" class="card-header-actions" (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
